<template>
  <div id="dashboard-covid">
    <!-- Logos -->
    <div class="vx-row" style="margin-top: 100px; margin-bottom: 100px;">
      <div class="vx-col w-1/3 sm:w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <img src="/partners/yemaachi.png" class="partner_logo" />
      </div>

      <div class="vx-col w-1/3 sm:w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base text-center">
        <h1 id="label">SeqCom-GH</h1>
        <span id="label_text">Sequencing for Covid Mitigation in Ghana</span>
      </div>
      <div class="vx-col w-1/3 sm:w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <img class="ml-auto partner_logo" src="/partners/waccip.png" />
      </div>
    </div>

    <div class="vx-row"></div>

    <!-- Intro -->
    <div class="vx-row" style="margin-top: 50px; margin-bottom: 50px;">
      <div class="vx-col w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <vx-card title="Welcome">
          <p>
            The SARS-CoV-2 virus continues to mutate leading to the emergence of new variants. A number of these variants have been associated with
            increased transmissibility, severity and/or immune evasion and have been identified as Variants of Concern/Interest. These are:
          </p>
          <br />
          <table>
            <tr>
              <td colspan="2"><b>Variants of Concern</b></td>
            </tr>
            <tr>
              <!-- <th style="color:#FF9F43">B.1</th>
              <td class="col-sm-9">First identified in Algeria/Morocco</td>
            </tr> -->
            </tr>

            <tr>
              <!--<th style="color:#28C76F">Alpha (B.1.1.7)</th>-->
              <th style="color:#1e1e1e">Alpha (B.1.1.7)</th>
              <td>First identified in the UK</td>
            </tr>
            <tr>
              <!-- <th style="color:#EA5455">Beta (B.1.351)</th> -->
              <th style="color:#1e1e1e">Beta (B.1.351)</th>
              <td class="col-sm-9">First identified in South Africa</td>
            </tr>
            <tr>
              <!--<th style="color:#7193FF">Gamma (P.1)</th>-->
              <th style="color:#1e1e1e">Gamma (P.1)</th>
              <td class="col-sm-9">First identified in Brazil</td>
            </tr>
            <tr>
              <!--<th style="color:#FF9F43">Delta (B.1.617.2)</th>-->
              <th style="color:#1e1e1e">Delta (B.1.617.2)</th>
              <td class="col-sm-9">First identified in India</td>
            </tr>
            <tr>
              <!--<th style="color:#e5ff00">Omicron (B.1.1.529)</th>-->
              <th style="color:#1e1e1e">Omicron (B.1.1.529)</th>
              <td class="col-sm-9">First identified in South Africa</td>
            </tr>
            <tr>
              <td colspan="2">&nbsp;<br /></td>
            </tr>
            <tr>
              <td colspan="2"><b>Variants of Interest</b></td>
            </tr>
            <tr>
              <th style="color:#ddd">Epsilon (B.1.427/B.1.429)</th>
              <td class="col-sm-9">First identified in United States</td>
            </tr>
            <tr>
              <th style="color:#ddd">Zeta (P.2)</th>
              <td class="col-sm-9">First identified in Brazil</td>
            </tr>
            <tr>
              <th style="color:#1E1E1E">Eta (B.1.525)</th>
              <td class="col-sm-9">First identified in Multiple countries</td>
            </tr>
            <tr>
              <th style="color:#ddd">Theta (P.3)</th>
              <td class="col-sm-9">First identified in Phillipines</td>
            </tr>
            <tr>
              <!--<th style="color:#af9d6a">Iota (B.1.526)</th>-->
              <th style="color:#1e1e1e">Iota (B.1.526)</th>
              <td class="col-sm-9">First identified in United States</td>
            </tr>
            <tr>
              <!--<th style="color:#4b9484">Kappa (B.1.617.1)</th>-->
              <th style="color:#1e1e1e">Kappa (B.1.617.1)</th>
              <td class="col-sm-9">First identified in India</td>
            </tr>
            <tr>
              <th style="color:#ddd">Lambda (C.37)</th>
              <td class="col-sm-9">First identified in Peru</td>
            </tr>
          </table>

          <br /><br />
          <p>
            This dashboard displays analysis of real-time data generated from sequencing of SARS-CoV-2 isolates collected from different locations
            across Ghana over the course of the pandemic. It is constantly updated to reflect the most up-to date data on the SARS-CoV-2 variants in
            Ghana.
          </p>
          <br /><br />
	  <p>
Samples from inbound international travellers sequenced by Noguchi Memorial Institute for Medical Research and data deposited on GISAID
          </p>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-2/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <vx-card title="Ghana SARS-CoV-2 Variant Distribution">
          <ghana-donut />
        </vx-card>
      </div>
    </div>

    <div class="vx-row" style="margin-top: 50px; margin-bottom: 50px;">
      <div class="vx-col w-full sm:w-full md:w-full flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <bar-chart />
      </div>
    </div>

    <div class="vx-row mb-3">
      <div class="vx-col w-full mb-base">
        <four-donuts />
      </div>
    </div>

    <div class="vx-row mb-3">
      <div class="vx-col w-full mb-base">
        <geo-map class="hello" />
      </div>
    </div>
  </div>
</template>

<script>
import GeoMap from '@/components/charts/GeoMap'
import BarChart from '@/components/charts/MainBarChart'
import FourDonuts from '@/components/charts/FourDonuts'
import GhanaDonut from '@/components/charts/GhanaDonut'

export default {
  components: {
    GeoMap,
    BarChart,
    FourDonuts,
    GhanaDonut
  }
}
</script>
<style>
dl.row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
dd {
  display: block;
}
#label {
  font-size: 40px;
}
#label_text {
  font-size: 14px;
}
.partner_logo {
  width: 200px;
}
@media (max-width: 600px) {
  #label {
    font-size: 14px;
  }
  #label_text {
    font-size: 8px;
  }
  .partner_logo {
    width: 90px;
  }
}
</style>
